<template>
  <InfuseTooltip :content="t('copied')" :show="show" :placement="placement" offset-distance="6">
    <slot :copy="copy" />
  </InfuseTooltip>
</template>

<script lang="ts" setup>
import { InfuseTooltip } from '@infuse/ui/components';
import { copyToClipboard } from '@infuse/utils';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
  closeDelay?: number;
  placement?:
    | 'auto'
    | 'auto-start'
    | 'auto-end'
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'right'
    | 'right-start'
    | 'right-end'
    | 'left'
    | 'left-start'
    | 'left-end';
}

const props = withDefaults(defineProps<Props>(), {
  placement: 'top',
  closeDelay: 2000
});

const { t } = useI18n();

const show = ref<boolean>(false);

let timer: NodeJS.Timeout;

function copy(textToCopy: string): void {
  copyToClipboard(textToCopy);

  show.value = true;
  clearTimeout(timer);
  timer = setTimeout(() => {
    show.value = false;
  }, +props.closeDelay);
}
</script>

<i18n>
{
  "en": {
    "copied": "Value copied"
  },
  "nl": {
    "copied": "Waarde gekopieerd"
  }
}
</i18n>
